import { API } from '@/config/api';
import { apiClient } from '@/shared/api/apiClient';

import type { AlertFilters, AlertPage, AlertSummary } from '../types';

const PAGE_SIZE = 20;

/** One page of the caller's notifications. Only the filters that are set are sent. */
export async function fetchAlerts(
  filters: AlertFilters,
  cursor: string | null,
): Promise<AlertPage> {
  const params: Record<string, unknown> = { size: PAGE_SIZE };
  const search = filters.search.trim();
  if (search) params.search = search;
  if (filters.category) params.category = filters.category;
  if (filters.priority) params.priority = filters.priority;
  if (filters.unreadOnly) params.unreadOnly = true;
  if (filters.starredOnly) params.starredOnly = true;
  if (cursor) params.cursor = cursor;
  return apiClient.get<AlertPage>(API.alerts, { params });
}

export async function fetchAlertSummary(): Promise<AlertSummary> {
  return apiClient.get<AlertSummary>(API.alertSummary);
}

export async function markAlertRead(id: string): Promise<void> {
  await apiClient.post<undefined>(API.alertRead(id));
}

export async function markAllAlertsRead(): Promise<number> {
  const answer = await apiClient.post<{ alertsChanged: number }>(API.alertsReadAll);
  return answer.alertsChanged;
}

export async function starAlert(id: string): Promise<void> {
  await apiClient.put<undefined>(API.alertStar(id));
}

export async function unstarAlert(id: string): Promise<void> {
  await apiClient.delete<undefined>(API.alertStar(id));
}

export async function deleteAlert(id: string): Promise<void> {
  await apiClient.delete<undefined>(API.alert(id));
}

/** Removes every read notification that is not starred. */
export async function clearReadAlerts(): Promise<number> {
  const answer = await apiClient.post<{ alertsChanged: number }>(API.alertsClearRead);
  return answer.alertsChanged;
}
